import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import CaseContextMenuButton from './CaseContextMenuButton';
import { LoadingSize } from '../../../../Components/Loading';

loadDOMComponent({
	selector: 'react-case-context-menu-button',
	callback: ({ container }: any) => {
		const caseId = container.getAttribute('caseId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider loadingSize={LoadingSize.SMALL}>
						<CaseContextMenuButton caseId={caseId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
